export default function(koCue, player, doneCallback, trackingData) {
  var self = this;
  var _doneCallback = doneCallback;
  var _koCue = koCue;
  var _player = player;
  var _attempts = [];
  var _ALLOWED_ATTEMPTS = 2;

  //build the view model from the cue
  self.questions = ko.observableArray();
  self.question = ko.observable();
  self.selectedOption = ko.observable();
  var _$selectedOptionRadioEl = null;
  self.currentImageUrl = ko.observable();
  self.questionState = ko.observable('question'); //question/correct/incorrect/explanation/larger/larger-explanation; two tries to guess correct answer
  self.isSubmitEnabled = ko.observable(false);
  self.moreAttemptsNotification = ko.observable(false);

  self.enableSubmit = function(opt, evt) {
    self.isSubmitEnabled(true);
    self.selectedOption(opt);
    _$selectedOptionRadioEl = $(evt.currentTarget).parent('.radio');
  };

  self.checkAnswer = function() {
    var opt = self.selectedOption();

    if(opt) {
      //ignore if attempted already
      if(_attempts.indexOf(opt) == -1) {
        _attempts.push(opt);

        if(opt.selected() != 'true') {
          if(_attempts.length < _ALLOWED_ATTEMPTS) {
            //mark option with an x
            _$selectedOptionRadioEl.addClass('student-question__incorrect');
            // show notification of more attempts
            self.moreAttemptsNotification(true);
            new Kadenze.Notice.error({
              message: Kadenze.I18n.t('session.media.try_again')
            });
          }
          else
          {
            //move on to uh oh screen
            self.questionState('incorrect');
          }
        }
        else
        {
          //show good job screen
          self.questionState('correct');
        }

        //Track when user clicks on Submit
        Kadenze.Analytics.track('video_quiz_question', 'submit', _.extend({}, trackingData,
          { cue: {question: self.question().question(), answer: self.selectedOption().answer(), state: self.questionState()}}));
      }
    }
  };

  self.viewFullSize = function(attachment, evt, state) {
    self.questionState(state);
    self.currentImageUrl(attachment.file.url());
  };

  self.continue = function() {
    if(_attempts.length > 0)
      self.question().lastAnswer = ko.observable(_attempts[_attempts.length - 1]); //store last answer for future use
    _doneCallback(false);
  };

  self.skip = function() {
    // Assuming nothing is selected when skipping the question, not doing so
    // was causing KADWEB-5901
    var answer = 'No answer selected.';

    _doneCallback(true);

    if(self.selectedOption()) {
      // If the user did select a question, report it.
      answer = self.selectedOption().answer();
    }

    //Track when user clicks on Skip
    Kadenze.Analytics.track('video_quiz_question', 'skip', _.extend({}, trackingData,
      { cue: {question: self.question().question(), answer: answer, state: self.questionState()}}));
  };

  //constructor
  console.log('constructor called for MediaQuestionPresenterViewModel');

  self.questions(_koCue.cued.field_definition());
  self.question(self.questions()[Math.floor(Math.random() * self.questions().length)]); //randomly select a question to ask

  //was there a previous attempt to answer?
  if(self.question().lastAnswer) {
    var opt = self.question().lastAnswer();
    self.selectedOption(opt);
  }
}

